module.exports = __webpack_public_path__ + "img/制御工学5_6_3.e416214f.png";